module.exports = __webpack_public_path__ + "img/popularize05.4e5957a4.png";